//Generated File 
export const ENTITY_TYPE = `entitytype`;
export const NAMA_PROTOCOL_PREFIX = `nama://`;
export const contextsSeparator = `_nctx_`;
export const entriesSepaarator = `_ntr_`;
export const keyValueSepaarator = `_nk_`;
export const listSeperator = `_nlst_`;
